import i18next from 'i18next'
import { useTranslation } from 'react-i18next'

import { TranslationFormat } from './customTranslation'

export const useCustomTranslation = (
  translationFile?: string
): {
  t: (key: string, format?: TranslationFormat, options?: Record<string, string | number>) => string
} => {
  const { t } = useTranslation(translationFile)
  return {
    t: (key: string, format?: TranslationFormat, options?: Record<string, string | number>) =>
      i18next.format(t(key, options), format),
  }
}
